import React, { useState } from 'react';
import { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

if (typeof window != 'undefined') {
  var QrReader = require('react-qr-reader');
}

export default function QRScanner({ onScan, ...rest }) {
  const [error, setError] = useState(false);
  const { t } = useTranslation();
  if (!process.browser) return null;
  if (error) {
    return (
      <div
        css={css`
          padding: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        `}
      >
        <h4>{t('general.utility.camera.error.title', 'No camera detected')}</h4>
        <div>
          {t(
            'general.utility.camera.error.subtitle',
            `Please check your camera's connection and ensure your camera is not already in use by another application.`
          )}
        </div>
      </div>
    );
  }
  return (
    <QrReader
      delay={300}
      onError={error => {
        console.log(error);
        setError(error);
      }}
      onScan={result => result && onScan(result)}
      style={{ width: '100%' }}
      {...rest}
    />
  );
}
